import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyCartProps {
  color: string;
}

const EmptyCart: React.FC<EmptyCartProps> = ({ color }) => {
  return (
    <div className="text-center mt-2">
      <h4 style={{ color }}>Oops! Carrinho está vazio</h4>
      <Link to={'/w'} className="btn btn-info">
        Adicionar itens
      </Link>
    </div>
  );
};

export default EmptyCart;
